<section *ngIf='show' style="padding: 20px;padding-top: 10px !important;padding-bottom: 0 !important;" class='no0'>
    <div class="col-12">
        <div class="card">
            <div class="card-header no">
                <h4 style="float: left;">All Visit : </h4>
                <div style="clear: both;margin-bottom: 5px;"></div>
                <div class="container-fluid">
                    <div class="row">
                        <div class="col-lg-3 col-12">
                            <input placeholder="Search By Name" [(ngModel)]='searchName' id='plaho' class="p-1 mb-2" type="text" style="width: 100%; height: 25px;border: 1px solid black !important; color: black !important;">
                        </div>
                        <div class="col-lg-3 col-12" *ngIf='add'>
                            <button (click)='addS()' style="height: 32px !important; width: 94.5% !important;border: 1px solid black !important;line-height:0; " type="button" class="btn btn-secondary mb-2">Add Visit</button>
                        </div>
                        <!-- <div class="col-lg-3 col-12">
                            <button (click)='trigger()' style="height: 45px !important; width: 94.5% !important;border: 1px solid black !important; " type="button" class="btn btn-secondary mb-2">Add Customer By File Excel</button>
                            <input id="excel" style="overflow: hidden !important;display: none;" name='excel' (change)='goFile($event)' class="text mt-2 d1" type="file" placeholder="الصور" required="">
                        </div> -->
                        <div class='col-lg-1 col-12'>
                            <button (click)='printert()' class="btn btn-secondary" style="height: 32px !important;border: 1px solid black !important;width: 94.5% !important;line-height:0;"><i class="fas fa-print"></i></button>
                        </div>
                    </div>
                </div>
            </div>

            <div class="card-body noer" style="padding: 0 !important;">
                <div class="table-responsive dfg" style="overflow: auto;height: 67.2vh;">


                    <div class="container" style="margin: 0 !important;max-width:100% !important;">
                        <table class="responsive-table" style="border-collapse: separate; /* Don't collapse */ border-spacing: 0;">
                            <thead>
                                <tr>
                                    <th style="text-align: center;">No.</th>
                                    <th scope="col">Name</th>
                                    <th scope="col">Occupation</th>
                                    <th scope="col">Address</th>
                                    <th scope="col">Mobile</th>
                                    <th scope="col">Email</th>
                                    <th scope="col">Abou_Us</th>
                                    <th scope="col">Interested</th>
                                    <th scope="col">Notes</th>
                                    <th scope="col">Time</th>
                                    <th scope="col">Date</th>
                                    <th scope="col" class='no'>Print</th>
                                    <!-- <th scope="col" class='no' *ngIf='update'>Update</th>
                                    <th scope="col" class='no' *ngIf='delete'>Delete</th> -->
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor='let v of arre|searchName:searchName|serchCodeSupplier:serchCodeVisit; let n = index;'>
                                    <th scope="row" style="text-align: center;">{{n+1}}</th>
                                    <td data-title="Name">{{v.name}}</td>
                                    <td data-title="Occupation">{{v.occupation}}</td>
                                    <td data-title="Address">{{v.adress}}</td>
                                    <td data-title="Mobile">0{{v.mobile}}</td>
                                    <td data-title="Email">{{v.email}}</td>
                                    <td data-title="Abou_Us">{{v.social}}</td>
                                    <td data-title="Interested">{{v.interested}}</td>
                                    <td data-title="Notes">{{v.notes}}</td>
                                    <td data-title="Time">{{v.time}}</td>
                                    <td data-title="Date">{{v.date| date: 'dd-MM-yyyy'}}</td>
                                    <td data-title="Delete" class='no'><button (click)='printQWE(v)' type="button" class="btn btn-dark" style="box-shadow: none;"><i class="fas fa-print"></i></button>
                                    </td>
                                    <!-- <td data-title="Update" class='no' *ngIf='update'><button (click)='upU(v)' type="button" class="btn btn-success" style="box-shadow: none;"><i class="fas fa-edit"></i></button></td>
                                                                        <td data-title="Delete" class='no' *ngIf='delete'><button (click)='delS(v.id , v.name)' type="button" class="btn btn-danger" style="box-shadow: none;"><i class="fas fa-trash-alt"></i></button>
                                    </td> -->
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>

        </div>
    </div>
    <section id="upd">
        <div class="main-w3layouts wrapper" style="z-index: 1;">
            <div class="main-agileinfo">
                <i (click)='close()' class="fas fa-times m-4" style="color: white; cursor: pointer;"></i>
                <div class="agileits-top">
                    <form #data='ngForm' (submit)='addS0(data.value)' style="direction: ltr !important;">
                        <span id="form00" style="display: block;">
                          <label style="color: white;">Name : </label>
          <input style="height: 25px;" class="text mt-2 d1" type="text" name="name" [(ngModel)]='name' placeholder="Name" required="">
          <label style="color: white;" class="mt-2">Occupation : </label>
          <input style="height: 25px;" class="text mt-2 d1" type="text" name="occupation" [(ngModel)]='occupation' placeholder="Occupation" required="">
          <label style="color: white;" class="mt-2">Email : </label>
          <input style="height: 25px;" class="text mt-2 d1" type="text" name="email" [(ngModel)]='email' placeholder="Email" required="">
          <label style="color: white;" class="mt-2">City : </label>
          <input style="height: 25px;" class="text mt-2 d1" type="text" name="city" [(ngModel)]='city' placeholder="City" required="">
          <label style="color: white;" class="mt-2">Address : </label>
          <input style="height: 25px;" class="text mt-2 d1" type="text" name="adress" [(ngModel)]='adress' placeholder="Address" required="">
          <label style="color: white;" class="mt-2">Area : </label>
          <input style="height: 25px;" class="text mt-2 d1" type="text" name="area" [(ngModel)]='area' placeholder="Area" required="">
          <label style="color: white;" class="mt-2">Phone : </label>
          <input style="height: 25px;" class="text mt-2 d1" type="number" name="phone" [(ngModel)]='phone' placeholder="Phone" required="">
          <label style="color: white;" class="mt-2">Phone2 : </label>
          <input style="height: 25px;" class="text mt-2 d1" type="number" name="phone2" [(ngModel)]='phone2' placeholder="Phone2" required="">
          <label style="color: white;" class="mt-2">Type : </label>
          <select [(ngModel)]='type' name="type" class="form-control mt-2" style="height: 25px !important; width: 100%; color: white !important;">
            <option disabled selected value="">Type</option>
            <option>Normal</option>
            <option>Family</option>
            <option>Vip</option>
            <option>Project</option>
    </select>
    <label style="color: white;" class="mt-2">Shift : </label>
    <select [(ngModel)]='shift' name="shift" class="form-control mt-2" style="height: 25px !important; width: 100%; color: white !important;">
      <option disabled selected value="">Shift</option>
      <option>Morning</option>
      <option>Evening</option>
</select>
<label style="color: white;" class="mt-2">About Us : </label>
<select [(ngModel)]='about' name="about" class="form-control mt-2" style="height: 25px !important; width: 100%; color: white !important;">
  <option disabled selected value="">About Us</option>
  <option>FaceBook</option>
  <option>Old Client</option>
  <option>BillBoards</option>
  <option>Bassing By</option>
  <option>Event</option>
  <option>Other</option>
</select>
<label style="color: white;" class="mt-2">Interested In : </label>
<select [(ngModel)]='interest' name="interest" class="form-control mt-2" style="height: 25px !important; width: 100%; color: white !important;">
  <option disabled selected value="">Interested In</option>
  <option>Modern Furniture</option>
  <option>Classic Furniture</option>
  <option>Vintage Furniture</option>
  <option>Contemporary Furniture</option>
  <option>Lighting</option>
  <option>Accessories</option>
</select>
<label style="color: white;" class="mt-2">Notes : </label>
<input style="height: 25px;" class="text mt-2 d1" type="text" name="notes" [(ngModel)]='notes' placeholder="Notes" required="">
          <!-- <input  class="text mt-2 d1" type="number" name="pay" [(ngModel)]='pay' placeholder="أضافة مدفوعات" required=""> -->
            <input style="margin-top: 1rem !important;width: 94.5% !important;float: left;" type="submit" value="Add">
            <div style="clear: both;"></div>
            </span>
                    </form>
                </div>
            </div>
        </div>
    </section>

</section>
<section class="loading">
    <div class="spinner">
        <div class="sk-circle">
            <div class="sk-circle1 sk-child"></div>
            <div class="sk-circle2 sk-child"></div>
            <div class="sk-circle3 sk-child"></div>
            <div class="sk-circle4 sk-child"></div>
            <div class="sk-circle5 sk-child"></div>
            <div class="sk-circle6 sk-child"></div>
            <div class="sk-circle7 sk-child"></div>
            <div class="sk-circle8 sk-child"></div>
            <div class="sk-circle9 sk-child"></div>
            <div class="sk-circle10 sk-child"></div>
            <div class="sk-circle11 sk-child"></div>
            <div class="sk-circle12 sk-child"></div>
        </div>
    </div>
</section>
<section id="upd-dd">
    <div class="main-w3layouts wrapper" style="z-index: 1;">
        <div class="main-agileinfo">
            <i (click)='closedd()' class="fas fa-times m-4" style="color: white; cursor: pointer;"></i>
            <div class="agileits-top">
                <span id="form00" style="display: block;">
        <input (click)='ok()' style="margin-top: 1rem !important;width: 94.5% !important;float: left;" type="submit" value="Delete confirmation">
        <div style="clear: both;"></div>
        </span>
            </div>
        </div>
    </div>
</section>
<section id="upd-up">
    <div class="main-w3layouts wrapper" style="z-index: 1;">
        <div class="main-agileinfo">
            <i (click)='closeUp()' class="fas fa-times m-4" style="color: white; cursor: pointer;"></i>
            <div class="agileits-top">
                <form #data124='ngForm' (submit)='okUp(data124.value)' style="direction: ltr !important;">
                    <span id="form00" style="display: block;">
              <input style="height: 25px;" class="text mt-2 d1" type="text" name="nameU" [(ngModel)]='nameU' placeholder="Name" required="">
              <input style="height: 25px;" class="text mt-2 d1" type="text" name="emailU" [(ngModel)]='emailU' placeholder="Email" required="">
              <input style="height: 25px;" class="text mt-2 d1" type="text" name="cityU" [(ngModel)]='cityU' placeholder="City" required="">
              <input style="height: 25px;" class="text mt-2 d1" type="text" name="adressU" [(ngModel)]='adressU' placeholder="Address" required="">
              <input style="height: 25px;" class="text mt-2 d1" type="text" name="areaU" [(ngModel)]='areaU' placeholder="Area" required="">
              <input style="height: 25px;" class="text mt-2 d1" type="number" name="phoneU" [(ngModel)]='phoneU' placeholder="Phone" required="">
              <input style="height: 25px;" class="text mt-2 d1" type="number" name="phone2U" [(ngModel)]='phone2U' placeholder="Phone 2" required="">
              <select [(ngModel)]='typeU' name="typeU" class="form-control mt-2" style="height: 25px !important; width: 100%; color: white !important;">
                <option disabled selected value="">Type</option>
                <option>Normal</option>
                <option>Family</option>
                <option>Vip</option>
                <option>Project</option>
        </select>
                <input style="margin-top: 1rem !important;width: 94.5% !important;float: left;" type="submit" value="Update">
                <div style="clear: both;"></div>
          </span>
                </form>
            </div>
        </div>
    </div>
</section>
<!-- <section id="upd023" style="overflow-y: scroll;">
  <div class="card text-center m-5" style="padding: 10px;overflow-x: scroll;">
      <i (click)='close0093()' class="fas fa-times m-4" style="color: black; cursor: pointer; text-align: right;"></i>
      <table class="table table-striped table-sm" style="text-align: center; direction: ltr;">
          <thead>
              <tr>
                  <th>Number</th>
                  <th>Bill Number</th>
                  <th>From Nogal</th>
                  <th>To Nogal</th>
                  <th>Remaining amount</th>
                  <th>Date</th>
              </tr>
          </thead>
          <tbody>
              <tr *ngFor='let v of arre0987; let n = index;'>
                  <th scope="row">{{n+1}}</th>
                  <td>{{v.id_bill}}</td>
                  <td>{{v.fromnogal}}</td>
                  <td>{{v.tonogal}}</td>
                  <td>{{v.total - v.pay}}</td>
                  <td>{{v.date|date: 'dd-MM-yyyy'}}</td>
              </tr>
          </tbody>
      </table>
  </div>
</section> -->
<section id="upd023" style="overflow-y: scroll;">
    <div class="card text-center m-5" style="padding: 10px;overflow-x: scroll;">
        <i (click)='close0093()' class="fas fa-times m-4" style="color: black; cursor: pointer; text-align: right;"></i>
        <div class="container-fluid">
            <div class="row">
                <div class="col-lg-2 col-12">
                    <label>From : </label><br>
                    <input id="fromDG" placeholder="Search By Code" class="p-1 mb-2 fromDA" type="date" style="width: 94.5%; height: 20px;border: 1px solid black !important; color: black !important;" value="2021-01-19">
                </div>
                <div class="col-lg-2 col-12">
                    <label>To : </label><br>
                    <input id="toDG" placeholder="Search By Code" class="p-1 mb-2 toDA" type="date" style="width: 94.5%; height: 20px;border: 1px solid black !important; color: black !important;" value="2021-01-26">
                </div>
                <div class="col-lg-3 col-12">
                    <label>Submit Search Date : </label><br>
                    <button (click)='goDate()' class="p-1 mb-2 btn btn-secondary" type="submit" style="width: 94.5%; height: 27px;border: 1px solid black !important;line-height:0;">Submit Search Date</button>
                </div>
                <div class="col-lg-2 col-12 lastU">
                    <label>QUotation_No : </label><br>
                    <select [(ngModel)]='quotationNS' class="form-control mb-2 select2 quotationNS" style="height: 45px !important; width: 100%;border: 1px solid black !important; color: black !important;">
<option disabled value="Search By QUotation No" selected>Search By QUotation No</option>
<option>All</option>
<option *ngFor='let w of supplierA|customerId:serchClient' [value]="w.id">{{w.id}}</option>
</select>
                </div>

            </div>
        </div>
        <table class="responsive-table" style="border-collapse: separate; /* Don't collapse */ border-spacing: 0;">
            <thead>
                <tr>
                    <th style='text-align:center;'>No.</th>
                    <th scope="col">QUotation_No</th>
                    <!-- <th scope="col">Order Date</th>
          <th scope="col">Shipping Date</th> -->
                    <th scope="col">Customer_Name</th>
                    <th scope="col">Money</th>
                    <th scope="col">Date</th>
                    <!-- <th scope="col">Available</th>
              <th scope="col">Defect</th>
              <th scope="col">Reseved</th>
              <th scope="col">Sales</th> -->
                    <!-- <th scope="col">Category</th>
          <th scope="col">Qty</th>

          <th scope="col">Price</th>
          <th scope="col">Supplier</th>
          <th scope="col">PI NO</th>
          <th scope="col">Sales</th> -->
                    <!-- <th scope="col">User</th> -->
                    <!-- <th scope="col" class='no'>Photo</th>
          <th scope="col" class='no' *ngIf='update'>Update</th>
          <th scope="col" class='no' *ngIf='delete'>Delete</th>
          <th scope="col" class='no'>Barcode</th> -->
                </tr>
            </thead>
            <tbody>
                <tr *ngFor='let v of arreDate|quotation:quotationNS|customerId:serchClient; let n = index;'>
                    <th scope="row" style='text-align:center;'>{{n+1}}</th>
                    <td data-title="QUotation_No">{{v.id_bill}}</td>
                    <td data-title="Customer_Name">{{v.nameCustomer}}</td>
                    <td data-title="Money">{{v.money}}</td>
                    <td data-title="Date">{{v.date|date: 'dd-MM-yyyy'}}</td>
                    <!-- <td data-title="Order Date">{{v.dateorder}}</td>
          <td data-title="Shipping Date">{{v.datereceipt}}</td> -->
                    <!-- <td data-title="Available">{{v.qty}}</td>
              <td data-title="Defect">{{v.defect}}</td>
              <td data-title="Reseved" (click)='waw(v)' style='cursor: pointer;'>{{v.mainqty - v.qty}}</td>
              <td data-title="Sales">{{v.qtyfinish}}</td> -->
                    <!-- <td data-title="Finishing/fabrics" >{{v.fabric}}</td>
          <td data-title="Category" >{{v.categoryname}}</td>
          <td data-title="Qty" >{{v.qty}}</td>
          <td data-title="Branch" >{{v.rootname}}</td>
          <td data-title="Price" >{{v.price}}</td>
          <td data-title="Supplier" >{{v.suppliername}}</td>
          <td data-title="PI NO" >{{v.pino}}</td>
          <td data-title="Sales" >{{v.sales}}</td> -->
                    <!-- <td data-title="Password" >{{v.username}}</td> -->
                    <!-- <td data-title="Photo" class='no'>
              <img class='shadow-lg' (click)='showpho(v.id)' (mouseenter)='goPic(v.url.url)' (mouseleave)='goPic0()' style='width:50px;height:50px;cursor: pointer;' [src]='v.url.url'>
          </td>
          <td data-title="Update" class='no'><button (click)='upI(v)' type="button" class="btn btn-success" style="box-shadow: none;"><i class="fas fa-edit"></i></button></td>
          <td data-title="Delete" class='no'><button (click)='delI(v.id)' type="button" class="btn btn-danger" style="box-shadow: none;"><i class="fas fa-trash-alt"></i></button>
          </td>
          <td data-title="Barcode" class='no'><button (click)='barcode(v)' type="button" class="btn btn-dark" style="box-shadow: none; background-color: black;"><i class="fas fa-barcode"></i></button>
          </td> -->
                </tr>
            </tbody>
        </table>
    </div>
</section>
<section class="asdfg">
    <div class="container-fluid">
        <div class="row">
            <div class='col-6 mb-5 pb-5'>
                <div style="background-color: black;display: inline-block;">
                    <img src="../../assets/video/logo.png">
                </div>
            </div>
            <div class="col-6 mb-5 pb-5">
                <div style="text-align: center;vertical-align: middle; height:100%;border:1px dashed black; position: relative;">
                    <h2 style="display: inline-block; font-size: 20px;position: absolute;top: 50%;left: 40%">BUSINESS CARD</h2>
                </div>
            </div>
            <div class="col-12 mb-5 pb-4">
                <h2 style="display: inline-block; font-size: 25px;">Date : </h2>&nbsp;&nbsp;
                <p style="font-size: 20px;display: inline-block;color:gray;"> {{DatePrint| date: 'dd-MM-yyyy'}}</p>
            </div>
            <div class="col-12 mb-5 pb-4">
                <h2 style="display: inline-block; font-size: 25px;">Time : </h2>&nbsp;&nbsp;
                <p style="font-size: 20px;display: inline-block;color:gray;"> {{TimePrint}}</p>
            </div>
            <div class="col-12 mb-5 pb-4">
                <h2 style="display: inline-block; font-size: 25px;">Shift : </h2>&nbsp;&nbsp;
                <p style="font-size: 20px;display: inline-block;color:gray;"> {{ShiftPrint}}</p>
            </div>
            <div class="col-12 mb-5 pb-4">
                <h2 style="display: inline-block; font-size: 25px;">Client Name : </h2>&nbsp;&nbsp;
                <p style="font-size: 20px;display: inline-block;color:gray;"> {{ClientPrint}}</p>
            </div>
            <div class="col-12 mb-5 pb-4">
                <h2 style="display: inline-block; font-size: 25px;">Occupation : </h2>&nbsp;&nbsp;
                <p style="font-size: 20px;display: inline-block;color:gray;"> {{OccupationPrint}}</p>
            </div>
            <div class="col-12 mb-5 pb-4">
                <h2 style="display: inline-block; font-size: 25px;">Adress : </h2>&nbsp;&nbsp;
                <p style="font-size: 20px;display: inline-block;color:gray;"> {{AdressPrint}}</p>
            </div>
            <div class="col-12 mb-5 pb-4">
                <h2 style="display: inline-block; font-size: 25px;">Mobile : </h2>&nbsp;&nbsp;
                <p style="font-size: 20px;display: inline-block;color:gray;"> 0{{MobilePrint}}</p>
            </div>
            <div class="col-12 mb-5 pb-4">
                <h2 style="display: inline-block; font-size: 25px;">E-mail : </h2>&nbsp;&nbsp;
                <p style="font-size: 20px;display: inline-block;color:gray;"> {{EmailPrint}}</p>
            </div>
            <div class="col-12 mb-5 pb-4">
                <h2 style="display: inline-block; font-size: 25px;">Where Did They Hear About Us ? </h2>&nbsp;&nbsp;
                <p style="font-size: 20px;display: inline-block;color:gray;"> {{AoutPrint}}</p>
            </div>
            <div class="col-12 mb-5 pb-4">
                <h2 style="display: inline-block; font-size: 25px;">Interested In : </h2>&nbsp;&nbsp;
                <p style="font-size: 20px;display: inline-block;color:gray;"> {{InterestPrint}}</p>
            </div>
            <div class="col-12">
                <h2 style="display: inline-block; font-size: 25px;">Notes : </h2>&nbsp;&nbsp;
                <p style="font-size: 20px;display: inline-block;color:gray;"> {{NotesPrint}}</p>
            </div>
        </div>
    </div>
</section>